import React ,{useState , useEffect , useReducer} from 'react';
import axios from 'axios';

import ButtonSection from '../components/button-section';
import InfoBulle from '../components/info-bulle';
import RadioBox from '../components/radio-box';
import When from '../components/when';
import logo from "../img/logo-bleu.webp";

const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }
};

export default function Logement(props) {
    //const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [dataValid, setDataValid] = useState(false);
    const [errors, setErrors] = useState([]);
    
    const [situationLogement , setSituationLogement] = useState();
    const [state , dispatch ] = useReducer( reducer , {
        pretPlusUnAn: true
    });

    const {step , restart , simulationData} = props;

    const optionsLogement = {
        'Locataire figurant sur le bail ou en foyer de logement' : 'locataire_vide',
        'Propriétaire' : 'proprietaire',
        'Hébergé chez un particulier ou en logement de fonction' : 'loge_gratuitement',
        'Sans domicile stable ou domiciliation administrative' : 'sans_domicile'
    };

    useEffect(()=>{
        setDataValid(isDataValid());
    } , [state,situationLogement]);

    const handleChangeSituationLogement = (newValue)=>(setSituationLogement(newValue));

    const isDataValid = ()=>{
        if (  typeof situationLogement === 'undefined'
         || typeof state.codePostal === 'undefined'
         || typeof state.ville === 'undefined'
        ){
            return false;
        }

        if ( situationLogement === 'proprietaire'){
            if (typeof state.primoAccedant === 'undefined')
                return false;
            if (typeof state.montantMensualite === 'undefined')
                return false
            return (
                !state.primoAccedant || 
                ( state.primoAccedant && typeof state.pretPlusUnAn !== 'undefined' )
            );
        }
        if ( situationLogement === 'loge_gratuitement'){
            return typeof state.participationFraisLogement !== 'undefined';
        }
        return true;
    }
    
    const getInputErrors = ()=>{
        var errors = [];
        if ( typeof situationLogement === 'undefined')
            errors.push("Veuillez renseigner votre situation de logement");

        if ( typeof state.codePostal === 'undefined'|| typeof state.ville === 'undefined')
            errors.push("Veuillez choisir une ville / commune avant de passer à l'étape suivante");
        
        if ( situationLogement === 'proprietaire'){
            if (typeof state.primoAccedant === 'undefined')
                errors.push("Veuillez indiquer si vous êtes primo-accédant");

            if (typeof state.montantMensualite === 'undefined')
                errors.push("Veuillez renseigner le montant des mensualités");
            
            /*if ( state.primoAccedant && typeof state.pretPlusUnAn === 'undefined' ){
                errors.push("");
            }*/
        }
        if ( situationLogement === 'loge_gratuitement' &&  typeof state.participationFraisLogement === 'undefined'){
            errors.push("Veuillez indiquer si vous participez aux frais de logement");
        }
        return errors;

    }

    const handleRadio = (newValue , model) => {
        dispatch(  {type:'update' , key: model , value: newValue});
    };

    const getCommunesFromPostCode = async (postCode)=> {
        const requestURI = "https://simulateurs.aide-sociale.fr/simulateur-aide-sociale/communes.php?code_postal=" + postCode;
        return axios.get(requestURI)
          .then ( (res)=>{
            return res.data;

          })
          .then ( (data)=>{
            const cities = data;
            const communes =  cities.map( (city) => ({ 'nom' :city.nom , 'insee': city.code}));

            return communes;

          });
    };

    const prepareCommunesInput = (postCode) => {
        //start loading animation
        dispatch( {type:'update' , key:'loadingCommunes' , value: true} );
        //stop loading animation
        getCommunesFromPostCode(postCode)
            .then((communes)=>{
                dispatch( {type:'update' , key:'communes' , value: communes});
                if (communes.length > 0 )
                    updateVille( communes[0].insee );
                dispatch( {type:'update' , key:'loadingCommunes' , value: false} );
            });
        
    }

    const changeCodePostal = (e)=> {
        const codePostal = e.target.value;
        if ( codePostal.length >= 6 ){
            e.target.value = codePostal.slice(0,5);
            return e.preventDefault();
        }
        if ( codePostal.length >= 5 ) {
            prepareCommunesInput(codePostal);
        };

        return dispatch( {type:'update' , key: 'codePostal' , value:codePostal} );
    };
    
    const goToNextStep = ()=>{
        if (dataValid) {
            const data ={};
            
            data.situationLogement = situationLogement;
            data.codePostal = state.codePostal;
            data.ville = state.ville;

            if ( data.situationLogement === "proprietaire" ) {
                data.montantMensualite = state.montantMensualite;
                data.pretPlusUnAn = state.pretPlusUnAn;
                data.primoAccedant = state.primoAccedant;
            }
            else if ( data.situationLogement === "loge_gratuitement" ) {
                data.participationFraisLogement = state.participationFraisLogement;
            }

            props.updateData( 'logement' , data);
            props.nextStep();
        } else {
            let curErrors = getInputErrors();
            setErrors(curErrors);
        }
    };

    const updateMontantMensualite = (e)=>{
        dispatch( {type:'update' , key:'montantMensualite'  , value:parseInt(e.target.value)});
    }
    const updateVille = (val) =>{
        dispatch( {type:'update' , key:'ville'  , value:val});
    }
    const infoPrimoAccedant = <p>Un primo-accédant est une personne (ou un ménage) qui n’a pas été propriétaire de sa résidence principale dans les deux années qui viennent de s’écouler au moment où il achète son bien.</p>;///
    const infoMensualite = <p>Laissez ce champ à 0 € si vous ne remboursez pas actuellement de crédit pour votre state.</p>;

    return <div id="logement" className="sim-form min-height" >
        <div className="container">
            <span className="heading-question">Quelle est votre situation de logement ?</span>
            <div style={{clear:"both"}}></div>
            <div className="question-set half situation-logement">
                <RadioBox
                    model={{situationLogement}}
                    handler={ handleChangeSituationLogement}
                    options={optionsLogement}
                ></RadioBox>
                <div  id="question-codepostal">
                    <div className="postcode-input">
                        <label>Votre code postal</label>
                        <input 
                          type="text"
                          id="codepostal"
                          className="form-control"
                          onChange={changeCodePostal}
                        />
                    </div>
                    <div className="postcode-input">
                        <label>Ville</label>
                        <When condition={!state.loadingCommunes && state.communes === undefined }>
                            <div className="empty-container blue-bg">
                                Saisissez un code postal
                            </div>
                        </When>
                        <When condition={state.loadingCommunes }>
                            <div className="empty-container blue-bg">
                                <span><i className="fa fa-spinner spin-animation"></i>Chargement</span>
                            </div>
                        </When>
                        {  state.communes !== undefined && !state.loadingCommunes?
                            <select className="custom-select blue-bg" onChange={e => (updateVille(e.target.value))} >
                                {
                                    state.communes.map((commune)=>{
                                        return <option value={commune.insee}>{commune.nom}</option>;
                                    })
                                }
                            </select> : ''
                        }

                    </div>
                </div>
            </div>
            <div className="question-set half left-side-separator">
                <When condition = {situationLogement === 'proprietaire'}> 
                    <RadioBox
                        model={state.primoAccedant}
                        name="primoAccedant"
                        options={{ "Oui": true, "Non" : false}}
                        handler={handleRadio}
                    >Êtes-vous primo-accédant pour cette propriété ? <InfoBulle message={infoPrimoAccedant}/></RadioBox>
                    <When condition = {state.primoAccedant !== undefined}>
                        <div className="question-set full-width">
                            <div className="question">
                                <label> Montant des mensualités <InfoBulle message={infoMensualite}/></label>
                            </div>
                            <div className="input">
                                <input type="number"
                                  name="montant-mensualite"
                                  className="form-control"
                                  placeholder= "Ex:500"
                                  onChange={updateMontantMensualite}
                                />
                            </div>
                        </div>
                    </When>
                    <When condition = {state.primoAccedant}>
                        <RadioBox
                             model={state.pretPlusUnAn}
                             name="pretPlusUnAn"
                             options={{ "Oui": true, "Non" : false}}
                             handler={handleRadio}
                        >Avez-vous signé votre prêt avant le 1er janvier 2021 ?</RadioBox>
                    </When>
                </When>
                <When condition = {situationLogement === 'loge_gratuitement'} > 
                    <RadioBox
                        model={state.participationFraisLogement}
                        name = "participationFraisLogement"
                        options={{ "Oui": true, "Non" : false}}
                        handler={handleRadio}
                    >Participez-vous aux frais de logement ?</RadioBox>
                </When>
            </div>            
        </div>

        <div style={{ marginTop:"2em" , clear:"both" }}></div>

        <ButtonSection
			restart={restart}
            action={goToNextStep}
            dataValid= {dataValid}
            errors={errors}
            data={simulationData}
            step={step}
        > 
        </ButtonSection>
    <div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
    </div>;

}